import { h } from 'preact'
import { t } from '../chat-i18n.js'
import { renderMarkdownPreview } from '../chat-markdown-editor.js'

/**
 * ReplyBar — shows above the composer when the user is replying to a message.
 *
 * Reads store.replyTo.value — renders nothing if null.
 *
 * Props: { store }
 */
export function ReplyBar({ store }) {
  const replyTo = store.replyTo.value
  if (!replyTo) return null

  const authorName   = replyTo.creator_person?.name || replyTo.creator_name || ''
  const rawText      = (replyTo.body || replyTo.body_preview || '').slice(0, 120)
  const previewHtml  = renderMarkdownPreview(rawText)
    || ((replyTo.has_attachments || replyTo.attachments?.length) ? '[melléklet]' : '—')

  function handleCancel() {
    store.replyTo.value = null
  }

  return (
    <div class="chat-reply-bar">
      <div class="chat-reply-bar-body">
        <span class="chat-reply-bar-label">{t('chat.messages.replying_to')}</span>
        {authorName && (
          <span class="chat-reply-bar-author">{authorName}</span>
        )}
        <span
          class="chat-reply-bar-text"
          dangerouslySetInnerHTML={{ __html: previewHtml }}
        />
      </div>
      <button
        type="button"
        class="chat-reply-bar-cancel"
        title={t('chat.rooms.cancel')}
        onClick={handleCancel}
      >
        <i class="bi bi-x-lg" />
      </button>
    </div>
  )
}
